import { hasProperty } from '../../../util/jquery';

export function marketsNewsListTransform(data) {
    const d = data.Data || {};
    const logosMap = generateNewsLogoMap(d);
    const ret = {
        news: (d.News || []).map(d => {
            return generateNewsObject(d, logosMap);
        })
    };
    if (hasProperty(d, 'TotalCount')) {
        ret.total = d.TotalCount;
    }
    return ret;
}

export function marketsNewsViewTransform(data) {
    const d = data.Data || {};
    const news = d.News && d.News.length ? d.News[0] : {};
    return generateNewsObject(news, generateNewsLogoMap(d));
}

export function marketsNewsLogosTransform(data) {
    const logos = data.Data || [];
    return logos.map(d => {
        return {
            hoverName: d.HoverName,
            id: d.LogoId,
            base64Image: d.Base64Image
        };
    });
}

export function marketsNewsSourcesTransform(data) {
    const sources = data.Data || [];
    return sources.map(d => {
        return {
            vendor: d.Vendor,
            providerCode: d.ProviderCode,
            serviceCode: d.ServiceCode,
            sourceCode: d.SourceCode,
            sourceName: d.SourceName
        };
    });
}

export function marketsNewsVendorsTransform(data) {
    return data.Data;
}

function generateNewsObject(d, logosMap) {
    if (Object.keys(d).length === 0) {
        return {};
    }
    const newsObj = {
        vendor: d.Vendor,
        publicationTime: d.PublicationTime,
        resourceId: d.ResourceId,
        title: d.Title,
        authors: (d.Authors || '').split(','),
        logoId: d.LogoId,
        providerCode: d.ProviderCode
    };
    if (logosMap.size) {
        const logoInfo = logosMap.get(d.LogoId) || {};
        newsObj.logoBase64Image = logoInfo.img || '';
        newsObj.logoAlt = logoInfo.alt;
    }
    if (d.TargetPublicationTime) {
        newsObj.targetPublicationTime = d.TargetPublicationTime;
    }
    if (d.Content) {
        newsObj.content = d.Content;
    }
    if (d.Template) {
        newsObj.template = d.Template;
    }
    if (d.Count) {
        newsObj.count = d.Count;
    }
    return newsObj;
}

function generateNewsLogoMap(d) {
    const map = new Map();
    if (hasProperty(d, 'Logos')) {
        d.Logos.forEach(logo => {
            map.set(logo.LogoId, {
                img: logo.Base64Image,
                alt: logo.HoverName
            });
        });
    }
    return map;
}
